import { FC } from 'react';
import styled from 'styled-components';

import PulsingLoader from '@/components/PulsingLoader';
import Text from '@/components/Text';

const Box = styled.div`
  min-height: 476px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
`;

const StyledText = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const Heading = styled(Text)`
  margin: 8px 0;
`;

const Description = styled(Text)`
  line-height: 22px;
  max-width: 264px;
  margin: auto;
`;

const LoaderHolder = styled.div`
  text-align: center;
`;

interface Props {
  isLoading?: boolean;
}

const ListPlaceholder: FC<Props> = ({ isLoading }) => {
  return (
    <Box>
      {isLoading ? (
        <LoaderHolder>
          <PulsingLoader />
          <Heading $type="button">Generating replies ...</Heading>
          <Description $color="gray" $type="captionSemibold">
            Please be patient, this action may take a little longer in some
            cases
          </Description>
        </LoaderHolder>
      ) : (
        <StyledText $color="gray" $type="caption">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.40625 6.66602H13.3322"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.40625 9.62891H13.3322"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.40625 12.5918H10.3692"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.025 18.5175H2.96144C2.76499 18.5175 2.57658 18.4359 2.43766 18.2907C2.29875 18.1455 2.2207 17.9485 2.2207 17.7431V2.25488C2.2207 2.04949 2.29875 1.85252 2.43766 1.70729C2.57658 1.56206 2.76499 1.48047 2.96144 1.48047H17.7763C17.9727 1.48047 18.1611 1.56206 18.3 1.70729C18.439 1.85252 18.517 2.04949 18.517 2.25488V12.7759C18.517 12.8776 18.4978 12.9783 18.4606 13.0722C18.4234 13.1662 18.3688 13.2515 18.3 13.3235L13.5488 18.2907C13.48 18.3626 13.3983 18.4196 13.3085 18.4586C13.2186 18.4975 13.1223 18.5175 13.025 18.5175V18.5175Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M18.4502 12.5918H13.332V17.7103"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          List is empty. Get comments & generate replies
        </StyledText>
      )}
    </Box>
  );
};

export default ListPlaceholder;
